import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { loadTasProgramInstanceHistory } from 'tio-data/requests/tas-program-instance';
import type { Store as StoreService } from '@warp-drive/core';
import type { TasProgramInstanceExtension as TASProgramInstanceModel } from 'tio-data/data/resources/tas-program-instance.ext';

export default class AuthenticatedTasProgramsShowHistoryRoute extends Route {
  @service declare store: StoreService;

  async model() {
    // @ts-expect-error seems like a bug or is the model a template?
    const { programInstance } = this.modelFor(
      'authenticated.tas.programs'
    ) as TASProgramInstanceModel;

    await loadTasProgramInstanceHistory(this.store, programInstance);

    return programInstance;
  }
}
